import { render, staticRenderFns } from "./View.vue?vue&type=template&id=4ed35797&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ed35797')) {
      api.createRecord('4ed35797', component.options)
    } else {
      api.reload('4ed35797', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=4ed35797&", function () {
      api.rerender('4ed35797', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/projects/View.vue"
export default component.exports